<template>
  <Modal
    class="scoped"
    full-height
    :modal-style="{ maxWidth: '900px' }"
    :title="`Apply Users to ${team.name}`"
  >
    <div class="card q-pa-md no-wrap full-height scroll">
      <div class="q-pa-md q-gutter-md">
        <h4>Select Users</h4>
        <QList>
          <QItemLabel header>
            <QItemSection>
              <QInput
                v-model="filter"
                dense
                filled
                placeholder="Filter by Name"
                size="sm"
                square
              />
            </QItemSection>
          </QItemLabel>
          <div class="row">
            <QSpinner
              v-if="loading"
              class="full-width q-mt-lg"
              :size="30"
            />
            <QItem
              v-for="user in filteredUsers"
              :key="user.id"
              class="col-md-3 col-sm-6"
            >
              <QItemSection
                side
                top
              >
                <QCheckbox
                  v-model="user.selected"
                  :label="user.name"
                  @update:model-value="toggleUser(user)"
                />
              </QItemSection>
            </QItem>
          </div>
        </QList>
      </div>
    </div>

    <template #buttons>
      <BaseButton
        color="primary"
        label="Confirm"
        new-design
        @click="confirm"
      />
    </template>
  </Modal>
</template>

<script>
import { sortBy } from "lodash-es";

import BaseButton from "shared/components/base/BaseButton.vue";
import Modal from "shared/components/core/modals/Modal.vue";
import { Organisation } from "shared/resources";

export default {
  name: "ManageTeamUsersModal",
  components: {
    Modal,
    BaseButton,
  },
  props: {
    organisationId: {
      type: [Number, String],
      required: true,
    },
    team: {
      type: Object,
      required: true,
    },
  },
  emits: ["confirm"],
  data() {
    return {
      teamUsers: [],
      updatedUsers: [],
      loading: false,
      filter: "",
    };
  },
  computed: {
    filteredUsers() {
      return this.teamUsers.filter((user) =>
        user.name.toLowerCase().includes((this.filter || "").toLowerCase())
      );
    },
  },
  mounted() {
    this.loadUsers();
  },
  methods: {
    async loadUsers() {
      this.loading = true;

      try {
        const { users } = (
          await Organisation.includes("users")
            .select({
              organisations: ["id"],
              users: ["name", "organisationTeamId"],
            })
            .find(this.organisationId)
        ).data;

        this.teamUsers = sortBy(
          users.map((user) => ({
            ...user,
            selected: user.organisationTeamId === this.team.id,
            updated: false,
          })),
          "name"
        );
      } catch (error) {
        this.$error("Something went wrong loading users", error);
      } finally {
        this.loading = false;
      }
    },
    toggleUser(user) {
      const updatedUser = this.updatedUsers.find(({ id }) => id === user.id);

      if (updatedUser) {
        updatedUser.organisation_team_id = user.selected ? this.team.id : null;
      } else {
        this.updatedUsers.push({
          ...user,
          organisation_team_id: user.selected ? this.team.id : null,
          updated: true,
        });
      }
    },
    confirm() {
      this.$emit("confirm", this.updatedUsers);
    },
  },
};
</script>
